import {Link} from "react-router-dom";

function LogoWidget(){
    
    return (
    <Link to="/">
    <img alt="" src="./img/logo6.png" className="img__logo"/>
    </Link>
    )
};

export default LogoWidget;